export default __webpack_public_path__ + "static/media/accueil.621b71e2.JPG";